export default class NavigationWrap {
  static init () {
    const navigationOpenToggle = document.getElementById('navigation-burger')
    const navigationCloseToggle = document.getElementById('navigation-close')

    if (!navigationOpenToggle || !navigationCloseToggle) {
      return
    }

    navigationOpenToggle.addEventListener('click', () => {
      document.getElementById('side-navigation').classList.add('open')
      document.body.classList.add('side-navigation-open')
    })
    
    navigationCloseToggle.addEventListener('click', () => {
      document.getElementById('side-navigation').classList.add('close')
      document.getElementById('side-navigation').classList.remove('open')
      document.body.classList.add('side-navigation-close')
      document.body.classList.remove('side-navigation-open')

      setTimeout(() => {
        document.getElementById('side-navigation').classList.remove('close')
        document.body.classList.remove('side-navigation-close')
      }, 500)
    })
  }
}
